// extracted by mini-css-extract-plugin
var _1 = "GoogleDrivePicker-module__animatedBackground--Vzqv2";
var _2 = "GoogleDrivePicker-module__buttons--vzW2S";
var _3 = "GoogleDrivePicker-module__content--jqhZy";
var _4 = "GoogleDrivePicker-module__modal--ZTqrY";
export { _1 as "animatedBackground", _2 as "buttons", _3 as "content", _4 as "modal" }
